export const PUBLIC_FEED_START = 'PUBLIC_FEED_START';
export const PUBLIC_FEED_STOP = 'PUBLIC_FEED_STOP';
export const PUBLIC_FEED_OPEN = 'PUBLIC_FEED_OPEN';
export const PUBLIC_FEED_CLOSE = 'PUBLIC_FEED_CLOSE';
export const PUBLIC_FEED_MESSAGE = 'PUBLIC_FEED_MESSAGE';
export const PUBLIC_FEED_CONNECT_REQUESTED = 'PUBLIC_FEED_CONNECT_REQUESTED';
export const PUBLIC_FEED_DISCONNECT_REQUESTED = 'PUBLIC_FEED_DISCONNECT_REQUESTED';
